<template>
    <el-dialog
        title="确认删除"
        :visible.sync="visible"
        width="500px"
        center>
        <div class="dialog-content">
            <div>
                <span>存在已经被用户领取但暂未使用的优惠券。</span>
                <span class="color-danger">如果删除这类优惠券，可能会引起用户投诉</span>
            </div>
            <div class="el-form--label-top">
                <label class="el-form-item__label">请确认删除策略:</label>
            </div>
            <div>
                <el-checkbox v-model="formData.hasOwn" :true-label="1" :false-label="0">删除已经被用户领取的优惠券</el-checkbox>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="saveCoupon">确认删除</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            formData: {
                hasOwn: 0
            },
            submitLoading: false
        };
    },
    methods: {
        show(id) {
            this.formData = {id, hasOwn: 0};
            this.visible = true;
        },
        // 保存
        async saveCoupon() {
            this.submitLoading = true;

            const res = await this.$request({
                url: '/coupon/delete',
                method: 'post',
                data: {...this.formData}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.submitLoading = false;
            });

            const { state, msg } = res.data;

            if(state !== '1') {
                this.$message.error(msg || '请求失败');
                return ;
            }

            this.$emit('submitSuccess');
            this.visible = false;
        }
    }
};
</script>
